import { filterNonAstNodes } from '../parser';
import { buildHole } from './match';
import { buildIdentifier, buildName } from './operand';
export const buildType = (node) => {
    const n = filterNonAstNodes(node)[0];
    if (node.kind === 'type-annot') {
        return buildType(n);
    }
    else if (n.kind === 'type-bounds') {
        const typeBounds = buildTypeBounds(n);
        if (typeBounds.bounds.length === 1) {
            return typeBounds.bounds[0];
        }
        else {
            return typeBounds;
        }
    }
    else if (n.kind === 'hole') {
        return buildHole(n);
    }
    else {
        return buildFnType(n);
    }
};
export const buildTypeBounds = (node) => {
    const nodes = filterNonAstNodes(node);
    const bounds = nodes.map(buildIdentifier);
    return { kind: 'type-bounds', parseNode: node, bounds };
};
export const buildGeneric = (node) => {
    const nodes = filterNonAstNodes(node);
    const name = buildName(nodes[0]);
    const bounds = nodes.at(1) ? buildTypeBounds(nodes[1]).bounds : [];
    return { kind: 'generic', parseNode: node, name, bounds: bounds };
};
export const buildFnType = (node) => {
    const nodes = filterNonAstNodes(node);
    let i = 0;
    const generics = nodes[i].kind === 'generics' ? filterNonAstNodes(nodes[i++]).map(buildGeneric) : [];
    const paramTypes = filterNonAstNodes(nodes[i++]).map(buildType);
    const returnType = buildType(filterNonAstNodes(nodes[i++])[0]);
    return { kind: 'fn-type', parseNode: node, generics, paramTypes, returnType };
};
//# sourceMappingURL=type.js.map